import Vue from 'vue';
import Router from 'vue-router';
import cookies from 'js-cookie';
import jwt from 'jsonwebtoken';
import moment from 'moment';
import error from './pages/error.vue';
import homeLayout from './layout/home.vue';
import defaultLayout from './layout/default.vue';
import login from './layout/login.vue';
import forgotPassword from './layout/forgot-password.vue';
import resetPassword from './layout/reset-password.vue';
import homePage from './pages/index.vue';
import admin from './layout/admin.vue';
import adminPage from './pages/admin/index.vue';
import manageUsers from './pages/admin/users/index.vue';
import manageProjects from './pages/admin/projects/index.vue';
import manageTagsRegions from './pages/admin/tags/index.vue';
import managePages from './pages/admin/pages/index.vue';
import manageDownloads from './pages/admin/downloads/index.vue';
import newPost from './pages/admin/projects/new.vue';
import editProjects from './pages/admin/projects/edit.vue';
import newUser from './pages/admin/users/new.vue';
import editUser from './pages/admin/users/edit.vue';
import newPage from './pages/admin/pages/new.vue';
import editPage from './pages/admin/pages/edit.vue';
import notificationsPage from './pages/projects.vue';
import dynamicPage from './components/dynamic-content/page.vue';
import dynamicProject from './components/dynamic-content/project.vue';
import advancedSearch from './pages/search.vue';
import profile from './pages/profile.vue';

Vue.use(Router);

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition;
		}
		return { x: 0, y: 0 };
	},
	routes: [
		{
			path: '/',
			name: 'home',
			meta: { layout: homeLayout, requiresLoggedIn: true },
			component: homePage
		},
		{
			path: '/login',
			name: 'login',
			meta: { layout: login }
		},
		{
			path: '/forgot-password',
			name: 'forgotPassword',
			meta: { layout: forgotPassword }
		},
		{
			path: '/reset-password/:token',
			name: 'resetPassword',
			meta: { layout: resetPassword }
		},
		{
			path: '/admin',
			name: 'admin',
			meta: { layout: admin, requiresLoggedIn: true, requiresAdmin: true },
			component: adminPage
		},
		{
			path: '/admin/users',
			name: 'manageUsers',
			meta: { layout: admin, requiresLoggedIn: true, requiresAdmin: true },
			component: manageUsers,
		},
		{
			path: '/admin/users/new',
			name: 'New user',
			meta: { layout: admin, requiresLoggedIn: true, requiresAdmin: true },
			component: newUser
		},
		{
			path: '/admin/users/:id',
			name: 'Edit user',
			meta: { layout: admin, requiresLoggedIn: true, requiresAdmin: true },
			component: editUser
		},
		{
			path: '/admin/projects',
			name: 'manageProjects',
			meta: { layout: admin, requiresLoggedIn: true, requiresAdmin: true },
			component: manageProjects,
		},
		{
			path: '/admin/projects/new',
			name: 'New projects',
			meta: { layout: admin, requiresLoggedIn: true, requiresAdmin: true },
			component: newPost
		},
		{
			path: '/admin/projects/:id',
			name: 'Edit projects',
			meta: { layout: admin, requiresLoggedIn: true, requiresAdmin: true },
			component: editProjects
		},
		{
			path: '/admin/tags',
			name: 'manageTagsRegions',
			meta: { layout: admin, requiresLoggedIn: true, requiresAdmin: true },
			component: manageTagsRegions
		},
		{
			path: '/admin/pages',
			name: 'managePages',
			meta: { layout: admin, requiresLoggedIn: true, requiresAdmin: true },
			component: managePages
		},
		{
			path: '/admin/downloads',
			name: 'manageDownloads',
			meta: { layout: admin, requiresLoggedIn: true, requiresAdmin: true },
			component: manageDownloads
		},
		{
			path: '/admin/pages/new',
			name: 'New page',
			meta: { layout: admin, requiresLoggedIn: true, requiresAdmin: true },
			component: newPage
		},
		{
			path: '/admin/pages/:id',
			name: 'Edit page',
			meta: { layout: admin, requiresLoggedIn: true, requiresAdmin: true },
			component: editPage
		},
		{
			path: '/projects',
			name: 'projects',
			meta: { layout: defaultLayout, requiresLoggedIn: true },
			component: notificationsPage
		},
		{
			path: '/page/:id',
			name: 'dynamicPage',
			meta: { layout: defaultLayout, requiresLoggedIn: true },
			component: dynamicPage
		},
		{
			path: '/project/:id',
			name: 'dynamicProject',
			meta: { layout: defaultLayout, requiresLoggedIn: true },
			component: dynamicProject
		},
		{
			path: '/search',
			name: 'advancedSearch',
			meta: { layout: defaultLayout, requiresLoggedIn: true },
			component: advancedSearch
		},
		{
			path: '/profile',
			name: 'My profile',
			meta: { layout: defaultLayout, requiresLoggedIn: true },
			component: profile
		},
		// catch all 404's
		{
			path: '*',
			name: '404 Not Found',
			meta: { layout: defaultLayout },
			component: error
		}
	],
});

router.beforeEach((to, from, next) => {
	if (to.matched.some(record => record.meta.requiresLoggedIn)) {
		const token = cookies.get('token');
		if (token) {
			const decodedToken = jwt.decode(token);
			const { exp, admin: isAdmin } = decodedToken;
			const now = moment().unix();
			if (now > exp) {
				next({
					path: '/login'
				});
			} else if (to.matched.some(record => record.meta.requiresAdmin) && !isAdmin) {
				next({
					path: '/'
				});
			} else {
				next();
			}
		} else {
			next({
				path: '/login'
			});
		}
	} else {
		next();
	}
});

export default router;
